module.exports = __webpack_public_path__ + "img/explode.2781403f.svg";